// React Query обвивката за историята на промените на складов документ.
// Ключът е под списъка на документа — ["inventory", "deliveries" | "writeoffs" |
// "stocktakes" | "transfers", "revisions", id] — затова `invalidateAll`
// (useInventory.ts) го чисти след всяка редакция, плащане или анулиране, без
// собствена инвалидация. `staleTime: 0` — модалът на документа се отваря наново
// след запис и трябва да види новата снимка веднага.
// В локален режим (каса без интернет) складът е извън обхвата → заявката мълчи.
import { useQuery } from "@tanstack/react-query";
import { getDocumentRevisions } from "../api/inventoryRevisions";
import { useIsEdgeLocal } from "./useEdgeMode";

export type RevisionDocumentGroup = "deliveries" | "writeoffs" | "stocktakes" | "transfers";

export const useDocumentRevisions = (group: RevisionDocumentGroup, movementId: number | null) => {
  const isLocal = useIsEdgeLocal();
  return useQuery({
    queryKey: ["inventory", group, "revisions", movementId],
    queryFn: () => getDocumentRevisions(movementId as number),
    enabled: movementId != null && !isLocal,
    staleTime: 0,
    retry: false,
  });
};
